let parametrosListaEdicoes = {
    "bs": { pagina: 0, limite: 10 },
    "tc": { pagina: 0, limite: 10 },
    "rd": { pagina: 0, limite: 10 },
    "bm": { pagina: 0, limite: 10 },
};
let _sigla = "";

let ParametrosListaProgramas = {
    "videos": { pagina: 0, limite: 20 },
    "podcasts": { pagina: 0, limite: 10 },
};
let ParametrosListaEpisodios = {
    "videos": { pagina: 0, limite: 10 },
    "podcasts": { pagina: 0, limite: 10 },
};
let _midia = "";

let parametrosListaFrases = {
    pagina: 0, limite: 10
};

let parametrosListaAreas = {
    pagina: 0, limite: 10
};

class Session {

    // EDIÇÕES
    static set setParametrosListaEdicoes(_parametros) {
        _sigla = _parametros.sigla;
        parametrosListaEdicoes[_sigla].pagina = _parametros.pagina;
        parametrosListaEdicoes[_sigla].limite = _parametros.limite;
    }

    static get getParametrosListaEdicoes() {
        return parametrosListaEdicoes;
    }

    static clearInfosEdicoes() {
        parametrosListaEdicoes = {
            "bs": { pagina: 0, limite: 10 },
            "tc": { pagina: 0, limite: 10 },
            "rd": { pagina: 0, limite: 10 },
            "bm": { pagina: 0, limite: 10 },
        };
        _sigla = "";
    }

    // PROGRAMAS
    static set setParametrosListaProgramas(_parametros) {
        _midia = _parametros.midia;
        ParametrosListaProgramas[_midia].pagina = _parametros.pagina;
        ParametrosListaProgramas[_midia].limite = _parametros.limite;
    }

    static get getParametrosListaProgramas() {
        return ParametrosListaProgramas;
    }

    static clearInfosProgramas() {
        ParametrosListaProgramas = {
            "videos": { pagina: 0, limite: 10 },
            "podcasts": { pagina: 0, limite: 10 },
        };
    }

    // EPISÓDIOS
    static set setParametrosListaEpisodios(_parametros) {
        _midia = _parametros.midia;
        ParametrosListaEpisodios[_midia].pagina = _parametros.pagina;
        ParametrosListaEpisodios[_midia].limite = _parametros.limite;
    }

    static get getParametrosListaEpisodios() {
        return ParametrosListaEpisodios;
    }

    static clearInfosEpisodios() {
        ParametrosListaEpisodios = {
            "videos": { pagina: 0, limite: 10 },
            "podcasts": { pagina: 0, limite: 10 },
        };
    }

    // ÁREAS ESPECIAIS
    static set setParametrosListaAreas(_parametros) {
        parametrosListaAreas.pagina = _parametros.pagina;
        parametrosListaAreas.limite = _parametros.limite;
    }

    static get getParametrosListaAreas() {
        return parametrosListaAreas;
    }

    static clearInfosAreas() {
        parametrosListaAreas = {
            pagina: 0, limite: 10
        };
    }

    // FRASES DO DIA

    static set setParametrosListaFrases(_parametros) {
        parametrosListaFrases = _parametros.pagina;
        parametrosListaFrases = _parametros.limite;
    }

    static get getParametrosListaFrases() {
        return parametrosListaFrases;
    }

    static clearInfosFrases() {
        parametrosListaFrases = {
            pagina: 0, limite: 10
        };
    }

}

export default Session